import Form from "./FamilyForm";
import CreateButton from "./FamilyCreateButton";
import ListItem from "./FamilyListItem";
import List from "./FamilyList";
import Input from "./FamilyInput";

export default {
  Form,
  CreateButton,
  ListItem,
  List,
  Input,
};
